// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__eS18U","normalXl":"styles_normalXl__Do+n-","normalLg":"styles_normalLg__3tIa7","normalMd":"styles_normalMd__tceWJ","normalSm":"styles_normalSm__Tyo6-"};